import requestApi from "../common/boxp_api_client";
import requestrApi from "../common/boxr_api_client";

// sales over view section and listing
const getSalesOverViewDetails = (params) => {
    return requestrApi({
        url: `/sales/quotes_header_details`,
        method: "GET",
        params
    });
};


const getSalesMainlisting = (params) => {
    return requestrApi({
        url: `/sales/listing_sales`,
        method: "GET",
        params
    });
}
const getAccountsHeader = (params) => {
    return requestrApi({
        url: `/sales/account_header_details`,
        method: "GET",
        params
    });
}
const createQuotation = (formData) => {
    return requestrApi({
        url: `sales/create_quotes`,
        method: "POST",
        data: formData
    });
}

const archiveWorkshopOrder = (id) => {
    return requestApi({
        url: `/header/${id}`,
        method: 'DELETE',
    })
}
const unArchiveWorkshop = (formData) => {
    return requestApi({
        url: `/unarchive_order?_method=PUT`,
        method: "POST",
        data: formData
    });
}
const sendQuotation = (formData) => {
    return requestrApi({
        url: `/sales/send_order_email`,
        method: "PUT",
        data: formData
    });
}
const updateHeaderDetails = (formData) => {
    return requestrApi({
        url: `/sales/edit_sales_order`,
        method: "PUT",
        data: formData
    });
}

const completeQuotation = (formData) => {
    return requestrApi({
        url: `/sales/complete_order`,
        method: "PUT",
        data: formData
    });
}

const updateSaveForLater = (formData) => {
    return requestrApi({
        url: `/sales/add_files`,
        method: "PUT",
        data: formData
    });
}
const getTabHeaderDetails = (params) => {
    return requestrApi({
        url: `/sales/sales_details`,
        method: "GET",
        params
    });
};
const getQuoteSaleItemDetails = (params) => {
    return requestrApi({
        url: `/sales/listing_sales_item`,
        method: "GET",
        params
    });
};
const getFinanceOverView = (params) => {
    return requestApi({
        url: `/finance_sales_items`,
        method: "GET",
        params
    });
};
const getFinanceFiles = (params) => {
    return requestrApi({
        url: `/sales/listing_files`,
        method: "GET",
        params
    });
}; const getFinanceFilesPhp = (params) => {
    return requestApi({
        url: `/get_finance_files`,
        method: "GET",
        params
    });
}; const getCoreExchangeFilesPhp = (params) => {
    return requestApi({
        url: `/core_supporting_documents`,
        method: "GET",
        params
    });
};


const getFinanceCoreDetails = (params) => {
    return requestApi({
        url: `/core_exchange_details`,
        method: "GET",
        params
    });
};
const getValidationMessage = (params) => {
    return requestrApi({
        url: `/sales/show_validation_message`,
        method: "GET",
        params
    });
};
const archiveSalesOrder = (formData) => {
    return requestrApi({
        url: `/sales/archive_sales_order`,
        method: "PUT",
        data: formData
    });
}

const updateEmailDetails = (formData) => {
    return requestrApi({
        url: `/sales/send_email_part_certifcate`,
        method: "PUT",
        data: formData
    });
}

// sales items 

function getPartNumber(params) {
    return requestrApi({
        url: "/primary_parts/primary_parts_dependencies",
        method: "GET",
        params
    });
}

const getCustomerList = (params) => {
    return requestApi({
        url: `/customers-list`,
        method: "GET",
        params
    });
};

function getNewPartCostPrimaryDetails(params) {
    return requestrApi({
        url: `/procurement_requests/primary_part_details`,
        method: "GET",
        params,
    });
}


function getNewPrimaryLineDetails(params) {
    return requestrApi({
        url: `/procurement_requests/primary_part_line_items`,
        method: "GET",
        params,
    });
}

function getAllSecondaryParts(params) {
    return requestrApi({
        url: `/primary_parts/fetch_secondary_parts`,
        method: "GET",
        params,
    });
}


const createSalesItem = (formData) => {
    return requestrApi({
        url: `/sales/create_sales_order`,
        method: "POST",
        data: formData
    });
}
const updateSalesItems = (formData) => {
    return requestrApi({
        url: `/sales/edit_sales_item`,
        method: "PUT",
        data: formData
    });
}
const deleteSalesItems = (formData) => {
    return requestrApi({
        url: `/sales/delete_sales_item`,
        method: "DELETE",
        data: formData
    });
}
const deleteCoreItems = (formData) => {
    return requestrApi({
        url: `/sales/delete_sales_core`,
        method: "DELETE",
        data: formData
    });
}

const uploadFinanceFiles = (formData) => {
    return requestApi({
        url: `/upload_finance_files`,
        method: "POST",
        data: formData
    });
}


// core exchange
function getAllCoreDetails(params) {
    return requestrApi({
        url: `/sales/listing_sales_core`,
        method: "GET",
        params,
    });
}
function getAllCoreExchange(params) {
    return requestrApi({
        url: `/sales/listing_cores`,
        method: "GET",
        params,
    });
}
//header for commercial/parts/core 
function getAllCoreHeader(params) {
    return requestrApi({
        url: `/sales/core_exchange_header`,
        method: "GET",
        params,
    });
}
// accounts core
function getAccountsCoreHeader(params) {
    return requestrApi({
        url: `/sales/account_core_header`,
        method: "GET",
        params,
    });
}
function getSalesCoreExchange(params) {
    return requestrApi({
        url: `/sales/listing_sales_tab_core`,
        method: "GET",
        params,
    });
}
function getAllRepaiablePArts(params) {
    return requestrApi({
        url: `/sales/sales_primary_parts_dependencies`,
        method: "GET",
        params,
    });
}
function getTraceRequirement(params) {

    return requestrApi({
        url: `/sales/listing_trace_items`,
        method: "GET",
        params,
    });
} function getDefaultRequirement(params) {

    return requestrApi({
        url: `/sales/listing_default_late_fee`,
        method: "GET",
        params,
    });
}
function createTraceRequirement(params) {

    return requestrApi({
        url: `/sales/create_trace_item`,
        method: "POST",
        data: params
    });
}

const createCoreItem = (formData) => {
    return requestrApi({
        url: `/sales/create_sales_core`,
        method: "POST",
        data: formData
    });
}
const createCoreExchange = (formData) => {
    return requestApi({
        url: `/create_sales_order_cores`,
        method: "POST",
        data: formData
    });
}
const updateCoreStatus = (formData) => {
    return requestrApi({
        url: `sales/set_core_status`,
        method: "PUT",
        data: formData
    });
}
const updateCoreReceipt = (formData) => {
    return requestrApi({
        url: `/sales/edit_receipt_item`,
        method: "PUT",
        data: formData
    });
}


const updateDefaultPenalty = (formData) => {
    return requestrApi({
        url: `/sales/edit_default_late_fee`,
        method: "PUT",
        data: formData
    });
}
// this endpoint is used in admin/core fee
const updateTraceItems = (formData) => {
    return requestrApi({
        url: `/sales/edit_trace_item`,
        method: "PUT",
        data: formData
    });
}

// this endpoint is used in create core exchange
const updateCoreTraceItems = (formData) => {
    return requestrApi({
        url: `/sales/edit_trace_core_sales`,
        method: "PUT",
        data: formData
    });
}
const updateCoreItem = (formData) => {
    return requestrApi({
        url: `/sales/edit_sales_core`,
        method: "PUT",
        data: formData
    });
}
// this is used for updating in core exchange page
const updateSubCoreTraceItem = (formData) => {
    return requestrApi({
        url: `/sales/edit_trace_listing`,
        method: "PUT",
        data: formData
    });
}
const updateSubRepairTraceItem = (formData) => {
    return requestrApi({
        url: `/sales/edit_repaire`,
        method: "PUT",
        data: formData
    });
}
const getGeneratedCoreReport = (params) => {
    return requestApi({
        url: `/generate_report`,
        method: "GET",
        params
    });
}
const getCorePageDetails = (params) => {
    return requestrApi({
        url: `/sales/sale_core_details`,
        method: "GET",
        params,
    });
}
const getSubCoreExchangeDetails = (params) => {
    return requestrApi({
        url: `/sales/listing_core_exchange_item`,
        method: "GET",
        params,
    });
}

const getReceiptDetails = (params) => {
    return requestrApi({
        url: `/sales/listing_recepit_table`,
        method: "GET",
        params,
    });
}
const getSubTraceDetails = (params) => {
    return requestrApi({
        url: `/sales/listing_trace_cores`,
        method: "GET",
        params,
    });
}
const getSubRepairDetails = (params) => {
    return requestrApi({
        url: `/sales/repair_table`,
        method: "GET",
        params,
    });
}
function getCostDetails(params) {

    return requestApi({
        url: `/cost_to_date`,
        method: "GET",
        params,
    });
}

const PartSalesServices = {
    getSalesOverViewDetails,
    getSalesMainlisting,
    createQuotation,
    sendQuotation,
    getTabHeaderDetails,
    getPartNumber,
    getCustomerList,
    getNewPartCostPrimaryDetails,
    getNewPrimaryLineDetails,
    getAllSecondaryParts,
    createSalesItem,
    updateSaveForLater,
    completeQuotation,
    getQuoteSaleItemDetails,
    updateHeaderDetails,
    updateSalesItems,
    getValidationMessage,
    archiveSalesOrder,
    updateEmailDetails,
    deleteSalesItems,
    getFinanceOverView,
    getAccountsHeader,
    getFinanceFiles,
    getFinanceFilesPhp,
    uploadFinanceFiles,
    getAllCoreDetails,
    getAllCoreExchange,
    getReceiptDetails,
    getAllRepaiablePArts,
    getTraceRequirement,
    createTraceRequirement,
    createCoreItem,
    createCoreExchange,
    getDefaultRequirement,
    updateDefaultPenalty,
    updateTraceItems,
    getCostDetails,
    deleteCoreItems,
    updateCoreItem,
    getSalesCoreExchange,
    getAllCoreHeader,
    getCorePageDetails,
    getSubCoreExchangeDetails,
    updateCoreStatus,
    getSubTraceDetails,
    updateSubCoreTraceItem,
    updateCoreReceipt,
    getFinanceCoreDetails,
    getCoreExchangeFilesPhp,
    getSubRepairDetails,
    updateCoreTraceItems,
    updateSubRepairTraceItem,
    getGeneratedCoreReport,
    getAccountsCoreHeader,
    archiveWorkshopOrder,
    unArchiveWorkshop
};

export default PartSalesServices;

